import React from "react";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  somethingWentWrongRoot: {
    height: "100vh",
    width: "100vw",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    "&>h4": {
      margin: "40px 0px 5px 0px",
    },
    "&>p": {
      marginBottom: "20px",
    },
  },
}));

export default function SomethingWentWrong() {
  const classes = useStyles();
  return (
    <div className={classes.somethingWentWrongRoot}>
      <h4>Oops! Something Went Wrong.</h4>
      <p>It's not you. It's us. Please give another try.</p>
      <button
        onClick={() => {
          window.location.reload();
        }}
      >
        Reload Page
      </button>
    </div>
  );
}
